import { render, staticRenderFns } from "./group-title.vue?vue&type=template&id=7168a5fa&scoped=true&lang=pug&"
import script from "./group-title.vue?vue&type=script&lang=js&"
export * from "./group-title.vue?vue&type=script&lang=js&"
import style0 from "./group-title.vue?vue&type=style&index=0&id=7168a5fa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7168a5fa",
  null
  
)

export default component.exports